import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Link,
  Divider,
  Modal,
  TextField,
  Grid,
  FormControl,
  MenuItem,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox, CircularProgress,
} from '@material-ui/core';
import { Autocomplete } from "@material-ui/lab";
import _ from 'lodash';
import axios from 'axios';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import qs from 'qs';
import PublisherForm from '../publishers/PublisherForm';
import useOpengraphData from "./useOpengraphData";
import useEffectExceptOnMount from "../../../helpers/useEffectExceptOnMount";
import RecentNews from "./RecentNews";
import CustomSnackbar from "../../user/shared/CustomSnackbar";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  actions: {
    justifyContent: 'flex-end'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  }
}))

const PieceOfNewsFo = ({ adminUserSession, pieceOfNewsId, newsTypes, onClose, open, afterCreatePieceOfNews, onDataUpdate, itemIndex, isDraft, initialInvestor, ...props }) => {
  const classes = useStyles();

  const [pieceOfNews, setPieceOfNews] = useState({
    title: '',
    source_url: '',
    news_type: '',
    funded_company_id: undefined,
    funded_property_id: undefined,
    news_category_ids: undefined,
    firm_ids: !!initialInvestor ? [initialInvestor.id] : [],
    firm_type: !!initialInvestor ? isDraft ? 'InvestorDraft' :  'Investor' : undefined,
    item_contact_ids: [],
    item_contact_type: undefined,
    publisher_id: undefined,
    article_content: '',
    written_at: null,
    medium: '',
    associated_items: !!initialInvestor ? {Investor: [{...initialInvestor, type: isDraft ? 'InvestorDraft' :  'Investor' }]} : {},
    image_url: ''
  });

  const [selectedInvestor, setSelectedInvestor] = useState(!!initialInvestor ? [initialInvestor] : []);
  const [selectedContact, setSelectedContact] = useState([]);
  const [selectedPublisher, setSelectedPublisher] = useState({});
  const [selectedFundedCompany, setSelectedFundedCompany] = useState({});
  const [selectedFundedProperty, setSelectedFundedProperty] = useState({});
  const [selectedNewsCategories, setSelectedNewsCategories] = useState([]);

  const [newsCategories, setNewsCategories] = useState([]);

  const [publishersData, setPublishersData] = useState({
    open: false,
    data: [],
  });
  const [investors, setInvestors] = useState({
    open: false,
    data: [],
  });
  const [contacts, setContacts] = useState({
    open: false,
    data: [],
  });
  const [fundedCompanies, setFundedCompanies] = useState({
    open: false,
    data: [],
  });

  const [fundedProperties, setFundedProperties] = useState({
    open: false,
    data: [],
  });

  const [errorMessage, setErrorMessage] = useState({});

  const [openPublisherForm, setOpenPublisherForm] = useState(false);
  const { loading, error, fetch, data } = useOpengraphData(adminUserSession);
  const [snackbar, setSnackbar] = useState({show: false, message: ''});

  useEffectExceptOnMount(() => {
    const title = data.title;
    const forbidden_words = ['NASDAQ:', 'NYSE:', 'NYSEARCA:', 'LSE:', 'ACQUIRES SHARES OF']
    if (forbidden_words.some(word => title.toUpperCase().includes(word))) {
      const newErrorMessage = {...errorMessage};
      newErrorMessage['title'] = "This news is not allowed";
      setErrorMessage(newErrorMessage);
    }
    setPieceOfNews(prev => ({...prev, ...data}));
  }, [data])

  useEffect(() => {
    handleFetchNewsCategories();
  }, [])

  useEffect(() => {
    setPieceOfNews(prevState => ({
      ...prevState,
      news_category_ids: selectedNewsCategories,
    }));
  }, [selectedNewsCategories])

  useEffect(() => {
    if (pieceOfNewsId) {
      axios.get(
        `/v1/admin/news/${pieceOfNewsId}/edit`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
      ).then((response) => {
        const {
          piece_of_news,
          extra_data,
          status: responseStatus
        } = response.data;

        const {
          id,
          logo,
          created_at,
          updated_at,
          admin_user_id,
          publisher_photo_url,
          news_categories_names,
          ...itemParams
        } = piece_of_news;

        if (isDraft) {
          const associated_items =  {
            ...itemParams.associated_items,
            Investor: [{...initialInvestor, type: isDraft ? 'InvestorDraft' :  'Investor' }],
          }
          setPieceOfNews({...itemParams, associated_items});

          setSelectedInvestor([initialInvestor, ...extra_data.ria_investor]);
        } else {
          setPieceOfNews(itemParams);

          setSelectedInvestor(extra_data.ria_investor);
        }
        setSelectedContact(extra_data.ria_contact);
        setSelectedFundedCompany(extra_data.funded_company);
        setSelectedFundedProperty(extra_data.funded_property);
        setSelectedPublisher(extra_data.publisher);
        setSelectedNewsCategories(extra_data.news_categories);

        fetch(itemParams.source_url)
      }).catch(function (thrown) {
        console.log('error', thrown.message)
      });
    }
  }, [pieceOfNewsId])

  const handleCreatePieceOfNews = (pieceOfNews) => {
    axios.post(
      '/v1/admin/news',
      qs.stringify({ piece_of_news: pieceOfNews }),
      {
        headers: {
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        },
      }
    ).then((response) => {
      const {
        data: {
          status,
          message,
        }
      } = response;

      if (status === 'success') {
        afterCreatePieceOfNews();
      } else if (status === 'duplicated') {
        setSnackbar({show: true, message: message})
      } else {
        setErrorMessage(message);
        console.log('message', message)
      }
    })
  }

  const handleUpdatePieceOfNews = (pieceOfNews) => {
    axios.put(
      `/v1/admin/news/${pieceOfNewsId}`,
      qs.stringify({ piece_of_news: pieceOfNews }),
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        status: statusUpdate,
        message,
        piece_of_news,
      } = response.data;

      if (statusUpdate === 'success') {
        onDataUpdate(piece_of_news, itemIndex);
      } else if (statusUpdate === 'duplicated') {
        setSnackbar({show: true, message: message})
      } else {
        setErrorMessage(message);
        console.log('message', message)
      }
    });
  }

  const handleFetchPublishers = (params = {}) => {
    const newParams = {
      page: 1,
      per_page: 50,
      ...params
    };

    axios.get(
      '/v1/admin/news/publishers',
      {
        params: newParams,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { publishers, status: responseStatus } = response.data;

      setPublishersData({
        open: true,
        data: publishers,
      })
    });
  }

  const handleFetchInvestors = (params = {}) => {
    const newParams = {
      page: 1,
      per_page: 50,
      ...params
    };

    axios.get(
      '/v1/admin/news/investors',
      {
        params: newParams,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { investors, status: responseStatus } = response.data;

      setInvestors({
        open: true,
        data: investors,
      })
    });
  }

  const handleFetchContacts = (params = {}) => {
    if (!!initialInvestor && !params.investor_id.find(el => el === initialInvestor.id)) {
      params = {
        ...params,
        investor_id: [initialInvestor.id].concat(params.investor_id)
      }
    }
    const newParams = {
      page: 1,
      per_page: 50,
      ...params
    };

    axios.get(
      '/v1/admin/news/contacts',
      {
        params: newParams,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { contacts, status: responseStatus } = response.data;

      setContacts({
        open: true,
        data: contacts,
      })
    });
  }

  const handleFetchFundedCompanies = (params = {}) => {
    const newParams = {
      page: 1,
      per_page: 50,
      ...params
    };

    axios.get(
      '/v1/admin/news/funded_companies_by_length',
      {
        params: newParams,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { funded_companies, status: responseStatus } = response.data;

      setFundedCompanies({
        open: true,
        data: funded_companies,
      })
    });
  }

  const handleFetchFundedProperties = (params = {}) => {
    const newParams = {
      page: 1,
      per_page: 50,
      ...params
    };

    axios.get(
        '/v1/admin/news/funded_properties',
        {
          params: newParams,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
    ).then((response) => {
      const { funded_properties, status: responseStatus } = response.data;

      setFundedProperties({
        open: true,
        data: funded_properties,
      })
    });
  }

  const handleFetchNewsCategories = () => {
    axios.get(
      '/v1/admin/news/news_categories',
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { news_categories, status: responseStatus } = response.data;

      setNewsCategories(news_categories);
    });
  }

  const handleOnChangeTitle = (event) => {
    event.persist();
    const forbidden_words = ['NASDAQ:', 'NYSE:', 'NYSEARCA:', 'LSE:', 'ACQUIRES SHARES OF']
    const title = event.target.value;
    if (forbidden_words.some(word => title.toUpperCase().includes(word))) {
      const newErrorMessage = {...errorMessage};
      newErrorMessage['title'] = "This news is not allowed";
      setErrorMessage(newErrorMessage);
    } else {
      const newErrorMessage = {...errorMessage};
      if (newErrorMessage['title']) {
        delete newErrorMessage['title']
        setErrorMessage(newErrorMessage);
      }
    }
    setPieceOfNews(prevState => ({
      ...prevState,
      ['title']: title,
    }));
  }

  const handleOnBodyChange = (event) => {
    event.persist();
    const forbidden_words = ['NASDAQ:', 'NYSE:', 'NYSEARCA:', 'LSE:', 'ACQUIRES SHARES OF']
    const body = event.target.value;
    if (forbidden_words.some(word => body.toUpperCase().includes(word))) {
      const newErrorMessage = {...errorMessage};
      newErrorMessage['article_content'] = "This news is not allowed";
      setErrorMessage(newErrorMessage);
    } else {
      const newErrorMessage = {...errorMessage};
      if (newErrorMessage['article_content']) {
        delete newErrorMessage['article_content']
        setErrorMessage(newErrorMessage);
      }
    }
    setPieceOfNews(prevState => ({
      ...prevState,
      ['article_content']: body,
    }));
  }

  const handleOnChange = (event) => {
    event.persist();

    setPieceOfNews(prevState => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  }

  const handleInputChangeAutocomplete = (event, field) => {
    event.persist();
    debounceFilterInput(event, field);
  }

  const debounceFilterInput = _.debounce((event, field) => {
    switch (field) {
      case 'publisher_id':
        handleFetchPublishers({ filter: event.target.value, publisher_id: pieceOfNews.publisher_id })
        break;
      case 'firm_ids':
        handleFetchInvestors({ filter: event.target.value, investor_id: pieceOfNews.firm_ids })
        break;
      case 'item_contact_ids':
        handleFetchContacts({ filter: event.target.value, investor_id: pieceOfNews.firm_ids, contact_id: pieceOfNews.item_contact_ids })
        break;
      case 'funded_company_id':
        handleFetchFundedCompanies({ filter: event.target.value, funded_company_id: pieceOfNews.funded_company_id })
        break;
      case 'funded_property_id':
        handleFetchFundedProperties({ filter: event.target.value, funded_property_id: pieceOfNews.funded_property_id })
        break;
    }
  }, 500)

  const hadleOpenPublishers = (open) => {
    if (open === true) {
      handleFetchPublishers({ publisher_id: pieceOfNews.publisher_id })
    } else {
      setPublishersData({
        open: false,
        data: [],
      })
    }
  }

  const hadleOpenInvestors = (open) => {
    if (open === true) {
      handleFetchInvestors({ investor_id: pieceOfNews.firm_ids })
    } else {
      setInvestors({
        open: false,
        data: [],
      })
    }
  }

  const hadleOpenContacts = (open) => {
    if (open === true && pieceOfNews?.firm_ids !== undefined) {
      handleFetchContacts({ investor_id: pieceOfNews.firm_ids, contact_id: pieceOfNews.item_contact_ids })
    } else {
      setContacts({
        open: false,
        data: [],
      })
    }
  }

  const hadleOpenFundedCompanies = (open) => {
    if (open === true) {
      handleFetchFundedCompanies({ funded_company_id: pieceOfNews.funded_company_id })
    } else {
      setFundedCompanies({
        open: false,
        data: [],
      })
    }
  }

  const hadleOpenFundedProperties = (open) => {
    if (open === true) {
      handleFetchFundedProperties({ funded_property_id: pieceOfNews.funded_property_id })
    } else {
      setFundedProperties({
        open: false,
        data: [],
      })
    }
  }

  const handleOnChangeAutocomplete = (field, selectedValue) => {
    let fieldData = {};

    let associatedItems = { ...pieceOfNews.associated_items };

    switch (field) {
      case 'firm_ids':
        fieldData = {
          firm_type: !_.isEmpty(selectedValue?.map((item) => item.id)) ? isDraft ? 'InvestorDraft' :  'Investor' : undefined,
          firm_ids: selectedValue?.map((item) => item.id),
          associated_items: {
            ...associatedItems,
            Investor: selectedValue?.map((item) => ({ id: item.id, name: item.name, type: isDraft ? 'InvestorDraft' :  'Investor' })),
          }
        }
        setSelectedInvestor(
            !!initialInvestor && !selectedValue.find(el => el.id === initialInvestor.id) ?
                [initialInvestor].concat(selectedValue) :
                selectedValue
        );
        break;
      case 'item_contact_ids':
        fieldData = {
          item_contact_type: !_.isEmpty(selectedValue?.map((item) => item.id)) ? 'Contact' : undefined,
          item_contact_ids: selectedValue?.map((item) => item.id),
          associated_items: {
            ...associatedItems,
            Contact: selectedValue?.map((item) => ({ id: item.id, name: item.name, type: 'Contact' })),
          }
        }

        setSelectedContact(selectedValue);
        break;
      case 'publisher_id':
        fieldData = {
          publisher_id: selectedValue?.id,
          publisher_name: selectedValue?.name,
        }

        setSelectedPublisher(selectedValue);
        break;
      case 'funded_company_id':
        fieldData = {
          funded_company_id: selectedValue?.id,
        }

        if (selectedValue !== undefined) {
          fieldData = {
            ...fieldData,
            associated_items: {
              ...associatedItems,
              FundedCompany: [{ id: selectedValue.id, name: selectedValue.name, type: 'FundedCompany' }]
            }
          }
        } else {
          fieldData = {
            ...fieldData,
            associated_items: {
              ...associatedItems,
            }
          }
        }

        setSelectedFundedCompany(selectedValue);
        break;

      case 'funded_property_id':
        fieldData = {
          funded_property_id: selectedValue?.id,
        }

        if (selectedValue !== undefined) {
          fieldData = {
            ...fieldData,
            associated_items: {
              ...associatedItems,
              FundedProperty: [{ id: selectedValue.id, name: selectedValue.name, type: 'FundedProperty' }]
            }
          }
        } else {
          fieldData = {
            ...fieldData,
            associated_items: {
              ...associatedItems,
            }
          }
        }

        setSelectedFundedProperty(selectedValue);
        break;
    }

    setPieceOfNews(prevState => ({
      ...prevState,
      ...fieldData,
    }));
  }

  const handleDateChange = (date) => {
    setPieceOfNews(prevState => ({
      ...prevState,
      written_at: date,
    }));
  }

  const handleSubmit = (event) => {
    event.persist();
    event.preventDefault();

    const blankValues = Object.keys(_.pickBy(pieceOfNews, (item) => ([null, undefined, ''].includes(item))));

    if (
        (pieceOfNews?.news_type === 'Investment Activity' && (blankValues.includes('funded_company_id') && blankValues.includes('funded_property_id')) ) || !_.isEmpty(errorMessage['title']) || !_.isEmpty(errorMessage['article_content'])
        || !_.isEmpty(_.intersection(blankValues, ['firm_ids', 'title', 'source_url', 'news_type', 'publisher_id', 'written_at', 'article_content', 'medium']))
    ) {
      console.log('error', blankValues)
      const message = {...errorMessage};

      blankValues.forEach((value) => {
        message[value] = "Can't be blank!"
      })

      console.log('message', message)

      setErrorMessage(message);
    } else if (pieceOfNewsId !== undefined) {
      handleUpdatePieceOfNews(pieceOfNews);
    } else {
      handleCreatePieceOfNews(pieceOfNews);
    }
  }

  const handleSelectOne = (id) => {
    const selectedIndex = selectedNewsCategories.indexOf(id);
    let newSelectedNewsCategories = [];

    if (selectedIndex === -1) {
      newSelectedNewsCategories = newSelectedNewsCategories.concat(selectedNewsCategories, id);
    } else if (selectedIndex === 0) {
      newSelectedNewsCategories = newSelectedNewsCategories.concat(
        selectedNewsCategories.slice(1)
      );
    } else if (selectedIndex === selectedNewsCategories.length - 1) {
      newSelectedNewsCategories = newSelectedNewsCategories.concat(
        selectedNewsCategories.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedNewsCategories = newSelectedNewsCategories.concat(
        selectedNewsCategories.slice(0, selectedIndex),
        selectedNewsCategories.slice(selectedIndex + 1)
      );
    }

    setSelectedNewsCategories(newSelectedNewsCategories);
  }

  const handleOpenNewPublisherModal = () => {
    setOpenPublisherForm(true);
  }

  const handleCloseNewPublisherModal = () => {
    setOpenPublisherForm(false);
  }

  const afterCreatePublisher = (publisher) => {
    setSelectedPublisher(publisher);

    setPieceOfNews(prevState => ({
      ...prevState,
      publisher_id: publisher?.id,
    }));
  }

  const handleOnClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      onClose();
    }
  }


  const formatValueForDatePicker = () => {
    if (pieceOfNews.written_at && (typeof pieceOfNews.written_at === 'string' || pieceOfNews.written_at instanceof String)) {
      return   new Date (pieceOfNews.written_at?.replace(/-/, '/').replace(/-/, '/'))
    }
    return  pieceOfNews.written_at
  }

  return (
    <Modal
      onClose={handleOnClose}
      open={open}
    >
      <>
      <Card
        className={classes.root}
      >
        <CardHeader title='Piece Of News Family Office' />
        <Divider />
        <CardContent>
          <Grid container spacing={3} >
            <Grid
                item

                xs={12}
            >
              <FormControl fullWidth>
                <TextField
                    label="Source URL"
                    variant="outlined"
                    name='source_url'
                    required
                    value={pieceOfNews.source_url || ''}
                    onChange={(e) => {
                      fetch(e.target.value);
                      handleOnChange(e);
                    }}
                />
                {
                  loading ? (<div style={{display: "inline-flex", verticalAlign: "center"}}>
                    <CircularProgress size={20}/>
                    <span style={{paddingLeft: 10, fontWeight: "normal", fontStyle: "italic"}}>Fetching metadata (title and image)</span>
                  </div>) : null
                }
                {
                  error ? (<span style={{paddingLeft: 10, fontWeight: "normal", fontStyle: "italic", color: "red"}}>Error fetching metadata, please fill in the title manually.</span>) : null
                }
                <span>{errorMessage['source_url']}</span>
              </FormControl>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <FormControl fullWidth>
                <TextField
                  label="Title"
                  variant="outlined"
                  name='title'
                  required
                  inputProps={{ maxLength: 500  }}
                  value={pieceOfNews.title || ''}
                  onChange={handleOnChangeTitle}
                />
                <span>{errorMessage['title']}</span>
              </FormControl>
            </Grid>

            {
              (pieceOfNews.image_url) ?(
                  <Grid style={{textAlign: "center"}}
                        item xs={12}>
                    <img

                        src={pieceOfNews.image_url}
                        style={{width: 300, height: 200, objectFit: "scale-down",
                          borderWidth:1, borderColor: '#707070', borderStyle: "solid"}}
                        alt={pieceOfNews.title}
                        loading="lazy"
                    />
                  </Grid>
              ) : null
            }

            <Grid
              item

              xs={12}
            >
              <FormControl fullWidth>
                <TextField
                  select
                  fullWidth
                  required
                  variant='outlined'
                  value={pieceOfNews.news_type}
                  label='News Type'
                  name='news_type'
                  onChange={handleOnChange}
                >
                  <MenuItem value="">
                    <em>Chose a Type</em>
                  </MenuItem>
                  {
                    newsTypes?.map((type, index) => <MenuItem key={`${type}-${index}`} value={type}>{type}</MenuItem>)
                  }
                </TextField>
                <span>{errorMessage['news_type']}</span>
              </FormControl>
            </Grid>

            <Grid
              item

              xs={12}
            >

              <FormControl fullWidth>
                {
                  newsCategories?.map((category) => (
                    <FormControlLabel
                      key={category.id}
                      control={
                        <Checkbox
                          checked={
                            selectedNewsCategories.includes(category.id)
                          }
                          name="news_categories_ids"
                          color="primary"
                          onChange={(event) => handleSelectOne(category.id)}
                          value={category.id}
                        />
                      }
                      label={category.name}
                    />
                  ))
                }
              </FormControl>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <Autocomplete
                multiple
                filterSelectedOptions={true}
                name="firm_ids"
                open={investors.open}
                onOpen={(event) => hadleOpenInvestors(true)}
                onClose={(event) => hadleOpenInvestors(false)}
                onChange={(event, value) => handleOnChangeAutocomplete('firm_ids', value)}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name || ''}
                value={selectedInvestor}
                options={investors.data}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Family Office"
                    variant="outlined"
                    onChange={(event) => handleInputChangeAutocomplete(event, 'firm_ids')}
                  />
                )}
                disabled={isDraft}
              />
              <span>{errorMessage['firm_ids']}</span>
            </Grid>

            {
              pieceOfNews.news_type === 'Investment Activity' ?
                  <>
                    <Grid
                        item

                        xs={12}
                    >
                      <Autocomplete
                          name="funded_company_id"
                          open={fundedCompanies.open}
                          onOpen={(event) => hadleOpenFundedCompanies(true)}
                          onClose={(event) => hadleOpenFundedCompanies(false)}
                          onChange={(event, value) => handleOnChangeAutocomplete('funded_company_id', value)}
                          getOptionSelected={(option, value) => option.id === value.id}
                          getOptionLabel={(option) => option.name || ''}
                          value={selectedFundedCompany}
                          options={fundedCompanies.data}
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Funded Company"
                                  variant="outlined"
                                  onChange={(event) => handleInputChangeAutocomplete(event, 'funded_company_id')}
                              />
                          )}
                      />
                      <span>{errorMessage['funded_company_id']}</span>
                    </Grid>

                    <Grid
                        item

                        xs={12}
                    >
                      <Autocomplete
                          name="funded_property_id"
                          open={fundedProperties.open}
                          onOpen={(event) => hadleOpenFundedProperties(true)}
                          onClose={(event) => hadleOpenFundedProperties(false)}
                          onChange={(event, value) => handleOnChangeAutocomplete('funded_property_id', value)}
                          getOptionSelected={(option, value) => option.id === value.id}
                          getOptionLabel={(option) => option.name || ''}
                          value={selectedFundedProperty}
                          options={fundedProperties.data}
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Funded Property"
                                  variant="outlined"
                                  onChange={(event) => handleInputChangeAutocomplete(event, 'funded_property_id')}
                              />
                          )}
                      />
                      <span>{errorMessage['funded_property_id']}</span>
                    </Grid>
                  </>

              : null
            }

            <Grid
              item

              xs={12}
            >
              <Autocomplete
                multiple
                filterSelectedOptions={true}
                name="item_contact_ids"
                open={contacts.open}
                onOpen={(event) => hadleOpenContacts(true)}
                onClose={(event) => hadleOpenContacts(false)}
                onChange={(event, value) => handleOnChangeAutocomplete('item_contact_ids', value)}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name || ''}
                value={selectedContact}
                options={contacts.data}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Family Office Contact"
                    variant="outlined"
                    onChange={(event) => handleInputChangeAutocomplete(event, 'item_contact_ids')}
                  />
                )}
              />
              <span>{errorMessage['item_contact_ids']}</span>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <div>
                <Autocomplete
                  name="publisher_id"
                  open={publishersData.open}
                  onOpen={(event) => hadleOpenPublishers(true)}
                  onClose={(event) => hadleOpenPublishers(false)}
                  onChange={(event, value) => handleOnChangeAutocomplete('publisher_id', value)}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.name || ''}
                  value={selectedPublisher}
                  options={publishersData.data}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Publisher"
                      variant="outlined"
                      onChange={(event) => handleInputChangeAutocomplete(event, 'publisher_id')}
                    />
                  )}
                />
                <Link onClick={handleOpenNewPublisherModal}>New Publisher</Link>
              </div>
              <span>{errorMessage['publisher_id']}</span>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <FormControl
                component="fieldset"
                fullWidth
              >
                <FormLabel component="legend">News Medium</FormLabel>
                <RadioGroup aria-label="medium" name="medium" value={pieceOfNews.medium || ''} onChange={handleOnChange}>
                  <FormControlLabel value="written" control={<Radio required />} label="Written" />
                  <FormControlLabel value="video" control={<Radio required />} label="Video" />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  disableToolbar
                  disableFuture
                  inputVariant="outlined"
                  label="Written At"
                  value={formatValueForDatePicker()}
                  onChange={handleDateChange}
                  format="yy-MM-dd"
                  openTo="year"
                  views={['year', 'month', 'date']}
                />
              </MuiPickersUtilsProvider>
              <span>{errorMessage['written_at']}</span>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <TextField
                fullWidth
                required
                label="Article Content"
                variant="outlined"
                name={'article_content'}
                onChange={handleOnBodyChange}
                value={pieceOfNews.article_content}
                multiline={true}
                rows={8}
              />
              <span>{errorMessage['article_content']}</span>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Button onClick={onClose}>Close</Button>
          <Button color="primary" variant="contained" onClick={handleSubmit}>Save</Button>
        </CardActions>

        {
          openPublisherForm ?
            <PublisherForm
              adminUserSession={adminUserSession}
              onClose={handleCloseNewPublisherModal}
              open={openPublisherForm}
              afterCreatePublisher={afterCreatePublisher}
            />
            : null
        }
      </Card>
      <RecentNews classes={classes}
                  selectedInvestor={selectedInvestor}
                  selectedContact={selectedContact}
                  adminUserSession={adminUserSession}
                  dataset={'FO'}
      />
      <CustomSnackbar
          open={snackbar.show}
          closeHandler={() => setSnackbar({show: false, message: ''})}
          message={snackbar.message}
          options={{
            severity: 'warning'
          }}
      />
    </>
    </Modal>
  )
}

export default PieceOfNewsFo;